// src/components/Advantages.js
import React from 'react';
import { applyImageFallback, getImageAssetUrl } from '../utils/imageAssets';

const advantages = [
  {
    icon: getImageAssetUrl('/images/advantages/advantage-global.webp'),
    fallbackIcon: '/images/advantages/advantage-global.png',
    title: 'Выкуп из США и Европы',
    text: 'Покупаем оригинальные товары из официальных магазинов, аутлетов и закрытых распродаж.',
  },
  {
    icon: getImageAssetUrl('/images/advantages/advantage-sale.webp'),
    fallbackIcon: '/images/advantages/advantage-sale.png',
    title: 'Скидки, outlet и private sale',
    text: 'Отбираем самые интересные акции, лимитированные предложения и выгодные находки каждый день.',
  },
  {
    icon: getImageAssetUrl('/images/advantages/advantage-order.webp'),
    fallbackIcon: '/images/advantages/advantage-order.png',
    title: 'Многолетний опыт и надёжность',
    text: 'Мы много лет работаем с зарубежными заказами и знаем нюансы официальных магазинов, аутлетов и распродаж. Ведём заказ спокойно и профессионально на каждом этапе.',
  },
];

const Advantages = () => {
  return (
    <section className="container advantages-modern-section">
      <div className="advantages-modern">
        <div className="advantages-modern-head">
          <p className="advantages-modern-kicker">Почему SHOPTOP BRANDS</p>
          <h2>Наши преимущества</h2>
          <p>
            Мы делаем выкуп за границей удобным и понятным: от поиска лучших предложений
            до оформления заказа и доставки.
          </p>
        </div>

        <div className="advantages-modern-grid">
          {advantages.map((item) => (
            <article className="advantage-modern-card" key={item.title}>
              <div className="advantage-modern-icon-wrap">
                <img
                  className="advantage-modern-icon-img"
                  src={item.icon}
                  alt={item.title}
                  loading="lazy"
                  decoding="async"
                  onError={(event) => applyImageFallback(event, item.fallbackIcon)}
                />
              </div>

              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
